import React, { useEffect, useState } from "react";
import { IReactSelect } from "../../../model/interface/keyValuePair";
import {
  updateSchool,
  getMiniCRMDistricts,
  getMiniCRMSchools,
} from "../../../api/miniCrm.service";
import { toast } from "react-toastify";
import Loader from "../../shared/loader/loader";
import Select from "react-select";
import { getStateAll, getGradeAll } from "../../../api/subject.service";
import SelectList from "../../../model/shared/selectList";
import MappedSchool from "./NWEA/mappedSchool";
import UnmappedSchool from "./NWEA/unmappedSchool";
import {
  getNWEASettings,
  getUnmappedNWEASchools,
  mapNWEASchools,
  updatetNWEASettings,
} from "../../../api/school.service";
import {
  getAllBundlesBySchoolId,
  updateBundleExtendedDate,
  updateBundleExtendedDateAll,
} from "../../../api/bundle.service";
import Breadcrumb from "../../shared/common/breadcrumb";
import constant from "../../../utils/constant";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { connect } from "react-redux";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import NWEASchoolSearch from "./NWEA/nweaSchoolSearch";
import moment from "moment";
import DatePicker from "react-datepicker";
import ExtendAllSubscriptionsModal from "./extendAllSubscriptionsModal";
import { useNumericParam } from "../../../utils/useNumericParam";

function SchoolDetail(props: any) {
  const defaultSelect = { label: "", value: 0 };
  const id = useNumericParam("id");
  const schoolId = id ? id : 0;
  const [grade, setGrades] = useState<Array<SelectList>>([]);
  const [selectedGrades, setSelectedGrades] = useState<Array<any>>([]);
  const [activeTab, setActiveTab] = useState<number>(1);
  const [NWEAActiveTab, setNWEAActiveTab] = useState<number>(1);
  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";

  const [editSchoolName, setEditSchoolName] = useState<string>();
  const [editSelectedState, setEditSelectedStates] = useState<IReactSelect>();
  const [editSelectedDistrict, setEditSelectedDistrict] =
    useState<IReactSelect>(defaultSelect);
  const [editCity, setEditCity] = useState<string>();
  const [editZip, setEditZip] = useState<string>();
  const [editClasslinkId, setEditClasslinkId] = useState<string>();
  const [isClassLinkActive, setIsClassLinkActive] = useState<boolean>(false);
  const [editCleverId, setEditCleverId] = useState<string>();
  const [isCleverActive, setIsCleverActive] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [states, setStates] = useState<Array<any>>([]);
  const [bundleInfo, setBundleInfo] = useState<Array<any>>([]);
  const [editIsNWEAEnabled, setEditNWEAEnabled] = useState<boolean>();
  const [districts, setDistricts] = useState<Array<any>>([]);
  const [enableNWEA, setEnableNWEA] = useState<boolean>(false);
  const [hasEnhancedPasswordSecurity, setHasEnhancedPasswordSecurity] =
    useState<boolean>(false);
  const [proctorModeEnabled, setProctorModeEnabled] = useState<boolean>(false);
  const [googleClassroomEnabled, setGoogleClassroomEnabled] =
    useState<boolean>(false);
  const [enableBulkSync, setEnableBulkSync] = useState<boolean>(false);
  const [isLocked, setIsLocked] = useState<boolean>(false);
  const [fileUpload, setFileUpload] = useState<boolean>(false);
  const [isMapped, setIsMapped] = useState<boolean>(false);
  const [isUnmapped, setIsUnmapped] = useState<boolean>(false);
  const [isNWEAEnabled, setIsNWEAEnabled] = useState<boolean>(false);
  const [schoolSearchModalOpen, setSchoolSearchModalOpen] =
    useState<boolean>(false);
  const [unmappedNWEASchools, setUnmappedNWEASchools] = useState<Array<any>>(
    []
  );
  const [school, setSchool] = useState<any>();
  const [isExtendModalOpen, setExtendModalOpen] = useState<boolean>(false);

  const getGrades = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let dropdownData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      dropdownData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrades(dropdownData);
    const selectedGradesData = [];
    const nweaSettings = await getNWEASettings(schoolId);
    if (nweaSettings.data.length > 0) {
      setSelectedGrades(isNWEAEnabled ? dropdownData : selectedGradesData);
      setEnableNWEA(nweaSettings.data[0].isNWEAEnabled);
      setEnableBulkSync(nweaSettings.data[0].isBulkSyncEnabled);
      setIsLocked(nweaSettings.data[0].isLocked);
    }
  };

  async function getSchoolDetail(schoolId) {
    setLoading(true);
    const params: any = {
      stateId: 0,
      schoolId: schoolId,
      region: "",
      districtId: 0,
      districtName: "",
      schoolName: "",
      orderByColumn: "Name",
      sortDir: "asc",
      pageSize: 10,
      pageNumber: 1,
    };
    const resp = await getMiniCRMSchools(params);

    if (resp && resp.data && resp.data.data && resp.data.data.length > 0) {
      const school: any = resp.data.data[0];
      setSchool(school);
      if (activeTab === 1) {
        getStates();
        setEditSchoolName(school?.name);
        setEditSelectedStates({
          label: school?.stateName,
          value: school?.stateId,
        });
        setEditSelectedDistrict({
          label: school?.districtName,
          value: school?.districtId,
        });
        setEditCity(school?.city);
        setEditZip(school?.zipCode);
        handleTabChange(2);
      }
      setEditClasslinkId(school?.classLinkId);
      setIsClassLinkActive(school?.isClassLinkActive);
      setEditCleverId(school?.cleverId);
      setIsCleverActive(school?.isCleverActive);
      if (school?.isNWEAEnabled) {
        setIsNWEAEnabled(true);
        setEditNWEAEnabled(true);
        handleTabChange(2);
      } else {
        setIsNWEAEnabled(false);
        setEditNWEAEnabled(false);
        handleTabChange(3);
      }
      setHasEnhancedPasswordSecurity(school?.hasEnhancedPasswordSecurity);
      setProctorModeEnabled(!!school?.proctorModeEnabled);
      setGoogleClassroomEnabled(!!school?.googleClassroomEnabled);
      setLoading(false);
    }
  }
  const updateGrades = () => {
    const gradesToUpdate: number[] = [];
    grade.forEach((grade) => {
      gradesToUpdate.push(grade.value);
    });
    updatetNWEASettings(
      schoolId,
      gradesToUpdate,
      enableNWEA,
      enableBulkSync,
      isLocked,
      props.profile?.userId
    ).then(() => {
      toast.success("School NWEA Grades Saved successfully");
      updateSchoolData();
    });
  };

  const startNWEASchoolMapping = () => {
    setIsMapped(false);
    setIsUnmapped(false);
    mapNWEASchools(schoolId, props.profile?.userId).then((response) => {
      if (response.data) {
        school.nweaId = response.data.nweaId;
        setSchool;
        setIsMapped(true);
      } else {
        loadUnmappedNWEASchool(schoolId);
      }
    });
  };

  function handleSchoolSearchModalOpen() {
    setSchoolSearchModalOpen(!schoolSearchModalOpen);
    setTimeout(() => {
      getSchoolDetail(schoolId);
    }, 500);
  }

  function loadUnmappedNWEASchool(schoolId) {
    getUnmappedNWEASchools(schoolId).then((response) => {
      const unmappedSchools: Array<any> = [];
      if (response.data.length > 0) {
        response.data.forEach((nweaSchool) => {
          const selectedSchool = { ...school };
          selectedSchool.nweaId = nweaSchool.nweaId;
          unmappedSchools.push(selectedSchool);
        });
        setUnmappedNWEASchools(unmappedSchools);
        setIsUnmapped(true);
      } else {
        toast.error("School mapping not found. Please try search option.");
      }
    });
  }
  const onUpdate = async () => {
    setLoading(true);
    if (editIsNWEAEnabled === true) {
      updateGrades();
    } else {
      updateSchoolData();
    }
  };

  const onMappingChanged = () => {
    setIsMapped(false);
    setIsUnmapped(false);
    setTimeout(() => {
      getSchoolDetail(schoolId);
    }, 500);
  };

  const updateSchoolData = async () => {
    try {
      const resp = await updateSchool({
        name: editSchoolName,
        schoolId: schoolId,
        stateName: editSelectedState?.label,
        stateId: editSelectedState?.value,
        districtName: editSelectedDistrict?.label,
        districtId: editSelectedDistrict?.value,
        classlinkId: editClasslinkId,
        isClassLinkActive: isClassLinkActive,
        cleverId: editCleverId,
        isCleverActive: isCleverActive,
        city: editCity,
        zip: editZip,
        updatedByUser: props?.profile?.userId,
        isNWEAEnabled: editIsNWEAEnabled,
        hasEnhancedPasswordSecurity: hasEnhancedPasswordSecurity,
        proctorModeEnabled: proctorModeEnabled,
        googleClassroomEnabled: googleClassroomEnabled,
      });
      setLoading(false);
      if (resp.status === 200) {
        toast.success("School updated successfully");
        getSchoolDetail(schoolId);
      } else {
        toast.error("School update failed");
      }
    } catch (e) {
      toast.error("School update failed");
    }
  };

  const onStateChange = async (e?) => {
    setLoading(true);

    setEditSelectedStates(e);

    const resp = await getMiniCRMDistricts({
      stateId: e.value,
      region: "",
      districtId: 0,
      districtName: "",
      orderByColumn: "",
      sortDir: "",
      pageSize: 9999,
      pageNumber: 1,
    });
    setLoading(false);
    if (resp && resp.data && resp.data.data) {
      setDistricts(
        resp.data.data.map((ds) => ({ label: ds.name, value: ds.districtId }))
      );
    }
  };
  const getStates = async () => {
    const resp: any = await getStateAll(9999, 1);
    if (resp && resp.data) {
      setStates(
        resp?.data?.data?.map((ds) => ({
          label: ds.name,
          value: ds.stateId,
        }))
      );
    }
  };
  const getBuldles = async (schoolId) => {
    const bundleinfo: any = await getAllBundlesBySchoolId(schoolId);
    if (bundleinfo && bundleinfo.data) {
      setBundleInfo(bundleinfo?.data);
    }
  };

  const handleTabChange = (tabId: number) => {
    setActiveTab(tabId);
    if (tabId === 2) getGrades();
  };

  const handleDateChange = (e, bundleId) => {
    const date = e;
    const updatedBundles = bundleInfo.map((bundle) => {
      if (bundle.bundleId === bundleId) {
        const updatedBundle = {
          ...bundle,
          extendedEndDate: date,
        };
        return updatedBundle;
      }

      return bundle;
    });
    setBundleInfo(updatedBundles);
  };

  const updateExtendedEndDate = async (accountId, bundleId, extendedDate) => {
    setLoading(true);

    try {
      const result = await updateBundleExtendedDate({
        bundleId: bundleId,
        extendedEndDate: moment(extendedDate).format("MM-DD-yyyy"),
        accountId: accountId,
      });
      setLoading(false);
      if (result.status === 200) {
        toast.success("Subscription updated successfully");
      } else {
        toast.error("Subscription update failed");
      }
    } catch (e) {
      toast.error("Subscription update failed");
    }
  };
  const handleNWEATabChange = (tabId: number) => {
    setNWEAActiveTab(tabId);
  };
  useEffect(() => {
    getSchoolDetail(schoolId);
    getBuldles(schoolId);
  }, [schoolId]);

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      {
        name: "CRM",
        url: constant.CRM,
        state: { crmType: constant.CRM_TYPE.SCHOOL },
      },
      {
        name: "School Details",
        url: "",
      },
    ];
    return items;
  };

  const handleOpenExtendModal = () => {
    setExtendModalOpen(true);
  };

  const handleCloseExtendModal = () => {
    setExtendModalOpen(false);
  };

  const handleExtendAllSubscriptions = async (newEndDate: Date) => {
    setLoading(true);

    try {
      const result = await updateBundleExtendedDateAll(
        schoolId,
        moment(newEndDate).format("MM-DD-yyyy")
      );
      setLoading(false);
      if (result.status === 200) {
        const newBundles = bundleInfo.map((bundle) => {
          return {
            ...bundle,
            extendedEndDate: newEndDate,
          };
        });

        setBundleInfo(newBundles);
        toast.success("Subscriptions updated successfully");
      } else {
        toast.error("Subscription update failed");
      }
    } catch (e) {
      toast.error("Subscription update failed");
    }

    handleCloseExtendModal();
  };

  return (
    <>
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                School Details
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <form>
              {loading && <Loader />}
              <div className="shadow border rounded-lg mt-4 px-4 py-6">
                <div>
                  <div className="mt-3 grid grid-cols-4 gap-4">
                    <div>
                      <span className="whitespace-nowrap">School Name</span>
                      <input
                        value={editSchoolName}
                        onChange={(e) => setEditSchoolName(e.target.value)}
                        type="text"
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-sm text-gray-700">State</label>
                      <Select
                        className="mt-1 text-sm"
                        value={editSelectedState}
                        options={states}
                        onChange={onStateChange}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                      />
                    </div>
                    <div>
                      <label className="text-sm text-gray-700">District</label>
                      <Select
                        className="mt-1 text-sm"
                        value={editSelectedDistrict}
                        options={districts}
                        // District changes must come through the Salesforce sync so user records stay in sync
                        isDisabled
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : state.isDisabled
                                ? "#F3F4F6"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                      />
                    </div>
                    <div>
                      <span className="whitespace-nowrap">City</span>
                      <input
                        value={editCity}
                        onChange={(e) => setEditCity(e.target.value)}
                        type="text"
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                    </div>
                    <div>
                      <span className="whitespace-nowrap">Zip</span>
                      <input
                        value={editZip}
                        onChange={(e) => setEditZip(e.target.value)}
                        type="text"
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <span className="whitespace-nowrap">Enable NWEA</span>
                        <input
                          checked={editIsNWEAEnabled}
                          onChange={() =>
                            setEditNWEAEnabled(!editIsNWEAEnabled)
                          }
                          type="checkbox"
                          className="mt-1 block w-5 h-5 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        />
                      </div>
                      <div>
                        <span className="whitespace-nowrap">
                          Enhanced Password Security
                        </span>
                        <input
                          checked={hasEnhancedPasswordSecurity}
                          onChange={() =>
                            setHasEnhancedPasswordSecurity(
                              !hasEnhancedPasswordSecurity
                            )
                          }
                          type="checkbox"
                          className="mt-1 block w-5 h-5 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 border-t pt-5">
                    <h3 className="font-semibold text-gray-700">
                      School Settings
                    </h3>
                    <div className="flex flex-wrap items-center gap-x-12 gap-y-3 mt-3">
                      <label
                        htmlFor="chkProctorModeEnabled"
                        className="flex items-center cursor-pointer pl-1"
                      >
                        <div className="mr-2 text-gray-700">
                          Proctor Mode Enabled
                        </div>
                        <div className="relative">
                          <input
                            id="chkProctorModeEnabled"
                            type="checkbox"
                            className="sr-only"
                            checked={proctorModeEnabled}
                            onChange={(e) =>
                              setProctorModeEnabled(e.target.checked)
                            }
                          />
                          <div
                            className={`${
                              proctorModeEnabled
                                ? "bg-primary-color "
                                : "bg-gray-300 "
                            } w-12 h-7 rounded-full shadow-inner`}
                          ></div>
                          <div
                            className={`${
                              proctorModeEnabled ? "toggle-btn" : ""
                            } absolute w-5 h-5 bg-white rounded-full shadow left-1 top-1 transition`}
                          ></div>
                        </div>
                      </label>
                      {school?.isDistrictCanvasConnected && (
                        <label
                          htmlFor="chkGoogleClassroomEnabled"
                          className="flex items-center cursor-pointer pl-1"
                        >
                          <div className="mr-2 text-gray-700">
                            Google Classroom Enabled
                          </div>
                          <div className="relative">
                            <input
                              id="chkGoogleClassroomEnabled"
                              type="checkbox"
                              className="sr-only"
                              checked={googleClassroomEnabled}
                              onChange={(e) =>
                                setGoogleClassroomEnabled(e.target.checked)
                              }
                            />
                            <div
                              className={`${
                                googleClassroomEnabled
                                  ? "bg-primary-color "
                                  : "bg-gray-300 "
                              } w-12 h-7 rounded-full shadow-inner`}
                            ></div>
                            <div
                              className={`${
                                googleClassroomEnabled ? "toggle-btn" : ""
                              } absolute w-5 h-5 bg-white rounded-full shadow left-1 top-1 transition`}
                            ></div>
                          </div>
                        </label>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-end pt-4">
                    <button
                      type="button"
                      onClick={() => onUpdate()}
                      className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    >
                      Update
                    </button>
                  </div>
                </div>
                <div className="pt-1">
                  <div className="flex items-center justify-between bg-gray-100 w-full mt-4">
                    <div className="flex">
                      <button
                        type="button"
                        className={isNWEAEnabled ? "block" : "hidden"}
                        onClick={() => {
                          handleTabChange(2);
                        }}
                      >
                        <h2
                          className={
                            activeTab === 2 ? activeTabClass : inActiveTabClass
                          }
                        >
                          NWEA
                        </h2>
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          handleTabChange(3);
                        }}
                      >
                        <h2
                          className={
                            activeTab === 3 ? activeTabClass : inActiveTabClass
                          }
                        >
                          Class Link
                        </h2>
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          handleTabChange(4);
                        }}
                      >
                        <h2
                          className={
                            activeTab === 4 ? activeTabClass : inActiveTabClass
                          }
                        >
                          Clever
                        </h2>
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          handleTabChange(6);
                        }}
                      >
                        <h2
                          className={
                            activeTab === 6 ? activeTabClass : inActiveTabClass
                          }
                        >
                          Subscription
                        </h2>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  id="body"
                  className={`${
                    NWEAActiveTab === 2 ? "h-51 overflow-scroll" : ""
                  }`}
                >
                  {activeTab === 2 && (
                    <>
                      <div className="pt-5">
                        <div className="grid grid-cols-2">
                          <div className="mt-2 flex flex-col gap-4">
                            <div className="flex items-center">
                              School NWEA Id{" "}
                              <input
                                id="districtNWEAId"
                                name="districtNWEAId"
                                type="text"
                                disabled={true}
                                value={school.nweaId ? school.nweaId : ""}
                                className="bg-gray-100 ml-4 block w-80 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              />
                              <button
                                type="button"
                                onClick={() => handleSchoolSearchModalOpen()}
                                className="ml-4  items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                              >
                                Search
                              </button>
                              <button
                                onClick={() => startNWEASchoolMapping()}
                                className="ml-4  items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                                type="button"
                              >
                                {school.nweaId
                                  ? "Remove Mapping"
                                  : "Start Mapping"}
                              </button>
                              {fileUpload && (
                                <input
                                  className=" border border-gray-300 shadow-sm py-1.5 px-4 inline-flex justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded-lg"
                                  type="file"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {(isMapped || isUnmapped) && (
                        <div>
                          <h1 className="mt-3 text-lg font-light text-gray-900 border-b mb-4">
                            {school.nweaId
                              ? "School Remove Mapping"
                              : "School Mapping"}
                          </h1>
                          <div className="mt-4 space-x-4 items-center">
                            {isMapped && (
                              <MappedSchool
                                userId={props.profile?.userId}
                                mappedSchool={school}
                                onMappingChanged={onMappingChanged}
                              />
                            )}
                            {isUnmapped && (
                              <UnmappedSchool
                                userId={props.profile?.userId}
                                unmappedSchool={school}
                                unmappedNWEASchools={unmappedNWEASchools}
                                onMappingChanged={onMappingChanged}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  {activeTab === 3 && (
                    <>
                      <div className="mt-4">
                        <div
                          className="bg-blue-100 rounded-lg py-5 px-6 mb-3 text-base text-blue-700 inline-flex items-center w-full"
                          role="alert"
                        >
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="info-circle"
                            className="w-4 h-4 mr-2 fill-current"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                            ></path>
                          </svg>
                          A school can have either classlink or clever enabled.
                          You cannot both have clever and classlink setting for
                          one school.
                        </div>
                      </div>
                      <div className="mt-4">
                        <label className="text-sm">Classlink Id</label>
                        <div className="grid grid-cols-3">
                          <div>
                            <input
                              value={editClasslinkId}
                              onChange={(e) => {
                                const value = e.target.value;
                                // PLP-5858: first-time ID entry (empty field + roster
                                // never configured, RosterUpdatedDate null) -> default Active.
                                if (
                                  !editClasslinkId &&
                                  value &&
                                  !school?.rosterUpdatedDate
                                ) {
                                  setIsClassLinkActive(true);
                                }
                                setEditClasslinkId(value);
                              }}
                              type="text"
                              autoComplete="off"
                              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-3">
                        <label
                          htmlFor="chkClassLinkActive"
                          className="flex items-center cursor-pointer pl-1 mt-2 grid grid-cols-4"
                        >
                          <div className="mr-2 text-gray-700 font-medium">
                            {isClassLinkActive ? "Active" : "Inactive"}
                          </div>
                          <div className="relative">
                            <input
                              id="chkClassLinkActive"
                              type="checkbox"
                              disabled={!editClasslinkId}
                              value={1}
                              className="sr-only"
                              checked={isClassLinkActive}
                              onChange={(e) => {
                                setIsClassLinkActive(e.target.checked);
                              }}
                            />
                            <div
                              className={`${
                                isClassLinkActive
                                  ? "bg-primary-color "
                                  : "bg-gray-300 "
                              } w-12 h-7 rounded-full shadow-inner`}
                            ></div>
                            <div
                              className={`${
                                isClassLinkActive ? "toggle-btn" : ""
                              } absolute w-5 h-5 bg-white rounded-full shadow left-1 top-1 transition`}
                            ></div>
                          </div>
                        </label>
                      </div>
                      <div className="flex justify-end pt-4">
                        <AllowedTo perform={Permissions.class_link_modify}>
                          <button
                            type="button"
                            onClick={() => onUpdate()}
                            className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                          >
                            Update
                          </button>
                        </AllowedTo>
                      </div>
                    </>
                  )}
                  {activeTab === 4 && (
                    <>
                      <div className="mt-4">
                        <div
                          className="bg-blue-100 rounded-lg py-5 px-6 mb-3 text-base text-blue-700 inline-flex items-center w-full"
                          role="alert"
                        >
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="info-circle"
                            className="w-4 h-4 mr-2 fill-current"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                            ></path>
                          </svg>
                          A school can have either classlink or clever enabled.
                          You cannot have both clever and classlink setting for
                          one school.
                        </div>
                      </div>
                      <div className="mt-4">
                        <label className="text-sm">District Clever Id</label>
                        <div className="grid grid-cols-3">
                          <div>
                            <input
                              disabled={true}
                              value={school.districtCleverId}
                              type="text"
                              autoComplete="off"
                              className="bg-gray-100 mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <label className="text-sm">Clever Id</label>
                        <div className="grid grid-cols-3">
                          <div>
                            <input
                              value={editCleverId}
                              onChange={(e) => {
                                const value = e.target.value;
                                // PLP-5858: first-time ID entry (empty field + roster
                                // never configured, RosterUpdatedDate null) -> default Active.
                                if (
                                  !editCleverId &&
                                  value &&
                                  !school?.rosterUpdatedDate
                                ) {
                                  setIsCleverActive(true);
                                }
                                setEditCleverId(value);
                              }}
                              type="text"
                              autoComplete="off"
                              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                      </div>
                      <label
                        htmlFor="chkCleverActive"
                        className="flex items-center cursor-pointer pl-1 mt-2 grid grid-cols-4"
                      >
                        <div className="mr-2 text-gray-700 font-medium">
                          {isCleverActive ? "Active" : "Inactive"}
                        </div>
                        <div className="relative">
                          <input
                            id="chkCleverActive"
                            type="checkbox"
                            disabled={!editCleverId}
                            value={1}
                            className="sr-only"
                            checked={isCleverActive}
                            onChange={(e) => {
                              setIsCleverActive(e.target.checked);
                            }}
                          />
                          <div
                            className={`${
                              isCleverActive
                                ? "bg-primary-color "
                                : "bg-gray-300 "
                            } w-12 h-7 rounded-full shadow-inner`}
                          ></div>
                          <div
                            className={`${
                              isCleverActive ? "toggle-btn" : ""
                            } absolute w-5 h-5 bg-white rounded-full shadow left-1 top-1 transition`}
                          ></div>
                        </div>
                      </label>
                      <div className="flex justify-end pt-4">
                        <AllowedTo perform={Permissions.clever_modify}>
                          <button
                            type="button"
                            onClick={() => onUpdate()}
                            className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                          >
                            Update
                          </button>
                        </AllowedTo>
                      </div>
                    </>
                  )}
                  {activeTab === 5 && (
                    <>
                      <div>
                        <h1 className="mt-2 text-lg font-light text-gray-900">
                          Google Details
                        </h1>
                      </div>
                    </>
                  )}
                  {activeTab === 6 && (
                    <>
                      <div>
                        <div className="flex justify-between items-center border-b mb-3">
                          <h1 className="mt-3 text-lg font-light text-gray-900 mb-3">
                            Bundle Info
                          </h1>
                          <button
                            type="button"
                            onClick={handleOpenExtendModal}
                            className="text-sm bg-primary-color hover:bg-secondary-color text-white py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline"
                          >
                            Extend Date for All
                          </button>
                        </div>

                        <div id="dataContainer" className="mt-4">
                          <div className="flex flex-col mt-1">
                            <div className="-my-2 sm:-mx-6 lg:-mx-8">
                              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div className="shadow border-b border-gray-200 sm:rounded-lg">
                                  <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-primary-color">
                                      <tr>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 pl-6 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          <span className="flex">
                                            Account Id
                                          </span>
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 pl-6 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          <span className="flex">
                                            Account Login Name
                                          </span>
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          Bundle Id
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          Name
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          Start Date
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          End Date
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          Extended End Date
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        ></th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {bundleInfo.map((bundle, index) => (
                                        <tr
                                          key={bundle.bundleId}
                                          className={
                                            index % 2 === 0
                                              ? "bg-white"
                                              : "bg-gray-100"
                                          }
                                        >
                                          <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 relative">
                                            {bundle.isActive ? (
                                              <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                            ) : (
                                              <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                            )}
                                            {bundle.accountId}
                                          </td>
                                          <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                            {bundle.accountLoginName}
                                          </td>
                                          <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-center font-normal text-gray-500">
                                            {bundle.bundleId}
                                          </td>
                                          <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-center font-normal text-gray-500">
                                            {bundle.name}
                                          </td>
                                          <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-center font-normal text-gray-500">
                                            {moment(bundle.startDate).format(
                                              "MM-DD-YYYY"
                                            )}
                                          </td>
                                          <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-center font-normal text-gray-500">
                                            {moment(bundle.endDate).format(
                                              "MM-DD-YYYY"
                                            )}
                                          </td>
                                          <td className="w-40 px-3 py-2  pl-6 whitespace-wrap text-sm text-center font-normal text-gray-500">
                                            <DatePicker
                                              wrapperClassName="mt-1"
                                              className="react-datepicker__input-container py-1.5 px-3 block shadow-sm focus:ring-primary-violet focus:border-primary-violet border border-gray-300 rounded-md text-gray-500"
                                              selected={
                                                bundle.extendedEndDate
                                                  ? new Date(
                                                      bundle.extendedEndDate
                                                    )
                                                  : null
                                              }
                                              onChange={(date) =>
                                                handleDateChange(
                                                  date,
                                                  bundle.bundleId
                                                )
                                              }
                                            />
                                          </td>
                                          <td>
                                            <AllowedTo
                                              perform={
                                                Permissions.subscription_modify
                                              }
                                            >
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  updateExtendedEndDate(
                                                    bundle.accountId,
                                                    bundle.bundleId,
                                                    bundle.extendedEndDate
                                                  )
                                                }
                                                className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                                              >
                                                Update
                                              </button>
                                            </AllowedTo>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </form>
            {schoolSearchModalOpen && (
              <NWEASchoolSearch
                handleSchoolSearchModalOpen={handleSchoolSearchModalOpen}
                schoolId={schoolId}
              />
            )}
          </div>
        </div>
      </div>
      <ExtendAllSubscriptionsModal
        isOpen={isExtendModalOpen}
        closeModal={handleCloseExtendModal}
        extendAllSubscriptions={handleExtendAllSubscriptions}
      />
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(SchoolDetail);
